import HttpMethodType from 'HttpMethodType';
import SubSystemType from 'SubSystemType';
import BaseServiceRequest from 'BaseServiceRequest';

class GetIsInSupportTimeRequest extends BaseServiceRequest {
    constructor(userId) {
        super();
        super.addPathParameter(userId.toString());
        super.addRequestUri("isinsupporttime.pb");
    }

    getMethod() {
        return HttpMethodType.GET;
    }

    getSubSystem() {
        return SubSystemType.USER;
    }

    getMessageName() {
        return "IsSupportTimeResponse";
    }
}

export default GetIsInSupportTimeRequest;